﻿var checkedClass = "bcfla-checked";

export function bindCheckboxEvents(targetControl:JQuery) {
    targetControl.find(".bcfla-checkboxlist:not(.bcfla-static) .btn").click(function () {
        hanteraCheckboxKlick(this);
    });

    targetControl.find(".bcfla-checkboxlist:not(.bcfla-static) .btn").on("change", function () {
        hanteraCheckboxKlick(this);
    });

    targetControl.find(".bcfla-radiobuttonlist:not(.bcfla-static) .btn").click(function () {
        hanteraRadioKlick(this);
    });

    targetControl.find(".bcfla-radiobuttonlist:not(.bcfla-static) .btn").on("change", function () {
        hanteraRadioKlick(this);
    });
}

export function getCheckboxlistValues(buttonGroupElement:JQuery) : string[] {
    var values:string[] = [];
    buttonGroupElement.find("button.bcfla-checked").each(function () {
        values.push($(this).attr("data-value"));
    });
    return values;
}

export function setCheckboxlistValues(buttonGroupElement:JQuery, values:string) : void {
    if (!buttonGroupElement || buttonGroupElement.length === 0 || !values || values.length === 0) return; // nothing to do

    var valuesArray: string[] = values.split(",");
    
    buttonGroupElement.find("button").each(function () {
        var thisval = $(this).attr("data-value");
        if (_.any(valuesArray, function (val) { return val == thisval; })) { // TODO: ersätt med indexof
            $(this).addClass("bcfla-checked");
        } else {
            $(this).removeClass("bcfla-checked");
        }
    });
}

function hanteraCheckboxKlick(btn:HTMLButtonElement) {
    $(btn).toggleClass(checkedClass);
}

function hanteraRadioKlick(btn:HTMLButtonElement) {
    if ($(btn).hasClass(checkedClass)) return;

    $(btn).siblings("." + checkedClass).removeClass(checkedClass);
    $(btn).toggleClass(checkedClass);
}

export function selectValue(select:JQuery, value:string) {
    select.find("option").each(function (idx, elem) {
        if ($(elem).prop("value") === value) {
            select.val(value)
            return
        }
    });
}

export function getSelectOptionText(select:JQuery) {
    var txt = "";
    select.find("option").each(function (idx, elem) {
        if ($(elem).prop("selected")) {
            txt = $(elem).html();
        }
    });
    return txt;
}

export function getSelectOptionValues(select:JQuery) : string[] {
    var vals:string[] = [];
    select.find("option").each(function (idx, elem) {
        if ($(elem).prop("selected")) {
            vals.push($(elem).attr("value"));
        }
    });
    return vals;
}
